import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 3;

export const migration_2_3:IMigration = {
    from: 2,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === 2);

        console.log('migration 2->3 designState', designState);

        if( designState.surface && designState.surface.artboard && designState.surface.artboard.allBoxes )
            Object.values(designState.surface.artboard.allBoxes).forEach((boxSnapshot:any) =>
            {
                const {componentDesc} = boxSnapshot;

                Object.values(componentDesc._layoutProperties).forEach(
                    (propSnapshot:any) =>
                    {
                        if( propSnapshot.name === 'alignment' ||
                            propSnapshot.name === 'verticalAlignment' )
                            delete componentDesc._layoutProperties[propSnapshot.id];
                    }
                );
            });

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
